import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import { TMatchMode } from '../types';

const getElementMatchMode = (
  currentElementIndex: number,
  allElementNumber: number,
  parentMatchMode: TMatchMode,
): TMatchMode => {
  if (parentMatchMode === 'match-fully') {
    return 'match-fully';
  }
  if (allElementNumber === 1) {
    return parentMatchMode;
  }
  if (currentElementIndex === 0) {
    return 'match-on-end';
  }
  if (currentElementIndex === allElementNumber - 1) {
    return 'match-on-start';
  }
  return 'match-fully';
};

/**
 * TODO
 * cell - '<b>Hello<b> world', fragmentToMatch = '<b>lo<b> world'
 */
const isStringMatching = (cell: string, fragmentToMatch: string, matchMode: TMatchMode): boolean => {
  if (matchMode === 'match-anywhere') {
    return cell.includes(fragmentToMatch);
  }
  if (matchMode === 'match-on-start') {
    return cell.startsWith(fragmentToMatch);
  }
  if (matchMode === 'match-on-end') {
    return cell.endsWith(fragmentToMatch);
  }
  return cell === fragmentToMatch;
};

const isRowMatching = (row: string[], fragmentToMatch: string[], matchMode: TMatchMode): boolean => {
  if (fragmentToMatch.length > row.length) {
    return false;
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < fragmentToMatch.length; i++) {
    if (!isStringMatching(row[i], fragmentToMatch[i], getElementMatchMode(i, fragmentToMatch.length, matchMode))) {
      return false;
    }
  }

  return true;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isArrayMatching = (table: string[], fragmentToMatch: string[][], matchMode: TMatchMode): boolean => {
  if (fragmentToMatch.length > table.length) {
    return false;
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < fragmentToMatch.length; i++) {
    if (!isRowMatching(table[i], fragmentToMatch[i], getElementMatchMode(i, fragmentToMatch.length, matchMode))) {
      return false;
    }
  }

  return true;
};

export const findTableFragmentPositionInTable = (
  table: string[][],
  tableFragmentToFind: string | string[] | string[][],
  [afterPositionRow, afterPositionColumn]: [number, number] = [0, 0],
): [number, number] | undefined => {
  if (isString(tableFragmentToFind)) {
    // eslint-disable-next-line no-plusplus
    for (let i = afterPositionRow; i < table.length; i++) {
      // eslint-disable-next-line no-plusplus
      for (let j = afterPositionColumn; j < table[i].length; j++) {
        if (isStringMatching(table[i][j], tableFragmentToFind, 'match-anywhere')) {
          return [i, j];
        }
      }
    }
  }

  if (isArray(tableFragmentToFind) && isString(tableFragmentToFind[0])) {
    // eslint-disable-next-line no-plusplus
    for (let i = afterPositionRow; i < table.length; i++) {
      // eslint-disable-next-line no-plusplus
      for (let j = afterPositionColumn; j < table[i].length; j++) {
        if (isRowMatching(table[i].slice(j), tableFragmentToFind, 'match-anywhere')) {
          return [i, j];
        }
      }
    }
  }

  if (isArray(tableFragmentToFind) && isArray(tableFragmentToFind[0])) {
    // eslint-disable-next-line no-plusplus
    for (let i = afterPositionRow; i < table.length; i++) {
      // eslint-disable-next-line no-plusplus
      for (let j = afterPositionColumn; j < table[i].length; j++) {
        const arrayToCheck = table.slice(i);
        arrayToCheck[0] = arrayToCheck[0].slice(j);
        if (isArrayMatching(arrayToCheck, tableFragmentToFind, 'match-anywhere')) {
          return [i, j];
        }
      }
    }
  }

  return undefined;
};
